<script setup lang="ts">
import { Head } from '@inertiajs/vue3'
import PageHeading from "@/Components/Headings/PageHeading.vue"
import { PageHeading as PageHeadingTS } from '@/types/PageHeading'
import { useFormatTime } from '@/Composables/useFormatTime'
import Tag from '@/Components/Utils/Tag.vue'
import { routeType } from '@/types/route'
import OrdersList from './OrdersList.vue'
import { ref } from 'vue'
import { useTruncate } from '@/Composables/useTruncate'
import Button from '@/Components/Utils/Button.vue'
import { Dialog } from 'primevue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPaperclip } from '@fal'
import { library } from '@fortawesome/fontawesome-svg-core'
import CreateInvoice from '@/Components/Master/Invoices/CreateInvoice.vue'
library.add(faPaperclip)

interface Order {
    id: number
    reference: string
    total: number
    product: {
        id: number
        name: string
        price: number
        type_icon: {
            tooltip?: string
            icon: string | string[]
            class?: string
        }
    }
    is_have_discount: boolean
    product_price_show: number
    quantity_show: number
    total_amount_show: number
    quantity: number
    total_amount: number
    final_total: number
}
interface Invoice {
    id: number
    orders: Order[]
    reference: string
    total_amount: number
    created_at: string
    sales: {
        id: number
        name: string
    }
    billing_date: string | null
    type: string
    due_date: Date | Date[] | (Date | null)[] | null | undefined
    type_label: string
}

const props = defineProps<{
    pageHead?: PageHeadingTS
    title?: string

    files: {}[]
    invoice_cash: Invoice
    invoice: Invoice
    invoice_type: {
        label: string
        value: string
    }[]
    route_list: {
        update_order_route: routeType
        reset_order_route: routeType
    }
    type_invoices?: {
        label: string
        value: string
    }[]
    init: {
        listSales?: {
            id: number
            name: string
        }[]
        selectedSalesId?: number
    }
}>()


// Section: Upload image
const isModalBuktiPelunasan = ref(false)
</script>

<template>
    <Head :title="title" />
    <PageHeading :data="pageHead">
        <template #afterTitle>
            <Tag v-if="invoice.billing_date && (invoice_cash ? invoice_cash.billing_date : true)" v-tooltip="useFormatTime(invoice.billing_date, {formatTime: 'hms'})" :theme="3" size="sm" noHoverColor>
                <template #label>
                    <FontAwesomeIcon icon='fal fa-check' class='' fixed-width aria-hidden='true' />
                    Lunas
                </template>
            </Tag>
        </template>

        
        <template #other>
            <CreateInvoice
                v-if="type_invoices"
                xinitListSales="props.init?.listSales"
                xinitSelectedSalesId="props.init?.selectedSalesId"
            />
        </template>
    </PageHeading>

<!-- Button: Bukti pelunasan -->
    <div class="px-6 mt-5">
        <Button v-if="files.length" @click="isModalBuktiPelunasan = true" icon="fal fa-paperclip" :label="`bukti pelunasan (${files.length})`" type="secondary" />
        <div v-else class="border-l-4 px-2 bg-gray-100 w-fit border-gray-400 italic text-gray-500">
            Belum ada bukti pelunasan dari sales
        </div>
    </div>

    <div class="mt-3 grid xl:grid-cols-2 gap-x-8 gap-y-8 px-6 divide-y divide-gray-500 xl:divide-y-0">
        <!-- Section: Invoice Transfer -->
        <OrdersList
            :invoice="invoice"
            :invoiceCross="invoice_cash"
            :updateOrderRoute="props.route_list.update_order_route"
            :resetOrderRoute="props.route_list.reset_order_route"
        />
        
        
        <!-- Section: Invoice Cash -->
        <OrdersList
            v-if="invoice_cash"
            :invoice="invoice_cash"
            :invoiceCross="invoice"
            :updateOrderRoute="props.route_list.update_order_route"
            :resetOrderRoute="props.route_list.reset_order_route"
        />
    </div>

    <Dialog
        :visible="isModalBuktiPelunasan" 
        :dismissableMask="true"
        :closable="true"
        modal
        :header="`Bukti pelunasan (${files.length})`"
        :style="{
            width: '70vw',
        }"
        :breakpoints="{ '1000px': '75vw', '575px': '90vw' }"
        @update:visible="(e: boolean) => isModalBuktiPelunasan = e"
    >
        <div class="">
            
            <!-- <input type="file" @change="uploadFile" id="input-avatar-large" name="input-avatar-large" class="sr-only" accept="image/*" /> -->
            
            
            <div class="grid grid-cols-1 lg:grid-cols-4 gap-x-4 gap-y-8 lg:gap-y-6 mt-2 pb-4 h-auto">
                <div v-for="(file, idxFile) in files" :key="file.id">
                    <div class="grid items-center border rounded-md border-gray-300 bg-gray-100 w-full h-fit max-h-[600px] lg:h-64 relative">
                        <img :src="file.file_path" class="mx-auto h-fit max-h-full rounded-md lg:rounded-none" />
                        <!-- <div class="absolute top-2 right-2">
                            <Button @click="(e) => openPopoverDelete(e, file.id)" type="negative" icon="far fa-trash-alt" />
                        </div> -->
                    </div>
                    <!-- <p class="break-all truncate overflow-ellipsis text-sm flex items-end">
                        {{ useTruncate(file.file_name, 40) }}
                    </p> -->
                    <p class="text-sm text-gray-600">
                        {{ idxFile+1 }}. {{ useFormatTime(file.created_at) }}
                    </p>
                </div>
<!-- 
                <div v-if="isShowSkeleton" class="skeleton w-full h-64 rounded-lg relative">
                </div> -->
                
                <!-- <div class="border border-dashed border-gray-400 rounded-xl w-full h-64 flex flex-col items-center justify-center relative overflow-hidden"
                    :class="message ? 'errorShake' : ''"
                >
                    <div v-if="isLoadingUpload" class="w-full flex flex-col items-center justify-center">
                        <LoadingIcon class="text-5xl" />
                        <span class="text-xl" :class="progress?.percentage === 100 ? 'text-green-500' : 'text-gray-400'">{{ progress?.percentage || 0 }}%</span>
                    </div>
                    <label v-else id="input-avatar-large-mask" for="input-avatar-large" class="absolute inset-0 flex flex-col items-center justify-center bg-gray-50 hover:bg-gray-200 cursor-pointer"
                    >
                        <FontAwesomeIcon icon='fal fa-plus' class='text-5xl' fixed-width aria-hidden='true' />
                        <span>Pilih gambar</span>
                        <span class="text-gray-400">(.jpeg, .jpg, .png)</span>
                        <div v-if="message" class="absolute bottom-2 text-red-500 italic text-sm">
                            *{{ message }}
                        </div>
                    </label>
                </div> -->
            </div>
        </div>
    </Dialog>
</template>